import React, { memo, useEffect, useState, FC } from 'react'
import { FormNames } from 'Src/constants/FormNames'
import { MAX_FILE_SIZE, MAX_FILES_COUNT } from 'Src/constants/Global'
import { useLocation } from 'react-router-dom'
import { useAppDispatch } from 'Src/hooks'
import { feedbackModalSlice, ModalTitleComponent } from 'Modules'
import { FieldNames } from 'Src/constants/FieldNames'
import { getInfoClient } from 'Helpers'
import { Callback } from 'Types/utilTypes'
import {
	FormNotificationComponent,
	i18n,
	UITypes,
	TextAreaComponent,
	AccordionComponent,
	UploadComponent,
	FormBlockComponent,
	Indent,
	BtnComponent,
} from 'LibNeo'
import { BlockButtons } from 'LibNeo/components/Basic/Buttons/Button/styled'
import Form, { FormComponentProps } from 'antd/lib/form'

interface ComponentProps extends FormComponentProps {
	close: Callback
}

const ModalFeedbackComponent: FC<ComponentProps> = ({ form, close }) => {
	const { pathname } = useLocation()
	const { postFeedback } = useAppDispatch({
		postFeedback: feedbackModalSlice.actions.createOne,
	})

	const [isEmpty, setIsEmpty] = useState(true)

	const bodyField = form.getFieldValue(FieldNames.BODY)

	useEffect(() => {
		setIsEmpty(!bodyField)
	}, [bodyField])

	const onSubmit = () => {
		const files = form.getFieldValue(FieldNames.FILES_ATTRIBUTES)
		const text = form.getFieldValue(FieldNames.BODY)
		const data = new FormData()
		let countFile = 0
		files?.forEach((file) => {
			data.append(`data[files_attributes][${(countFile += 1)}][file]`, file)
		})
		data.append('data[body]', text + getInfoClient())

		postFeedback(data)
		close()
	}

	const isOrderPathname = () => {
		pathname.includes('orders_redesign/edit/')
	}

	return (
		<>
			<ModalTitleComponent
				title={
					isOrderPathname
						? i18n('modals.feedback.consent_page.title')
						: i18n('modals.feedback.common.title')
				}
			/>
			<FormBlockComponent>
				<FormNotificationComponent
					type={UITypes.INFO}
					message={
						isOrderPathname
							? i18n('modals.feedback.consent_page.text')
							: i18n('modals.feedback.common.text')
					}
				/>
			</FormBlockComponent>
			<FormBlockComponent>
				<TextAreaComponent label="Текст обращения" fieldName={FieldNames.BODY} form={form} />
			</FormBlockComponent>
			<FormBlockComponent>
				<AccordionComponent
					noExpand
					id="attachment"
					titleText="Вложение"
					description="При необходимости, приложите скриншот в формате: jpg,png,jpeg,pdf,.tiff"
				>
					<Indent top={24}>
						<UploadComponent
							maxFilesCount={MAX_FILES_COUNT}
							acceptedFiles=".jpg,.png,.jpeg,.pdf,.tiff"
							btnTitle="Загрузить файл"
							form={form}
							multiple
							maxFileSize={MAX_FILE_SIZE}
							fieldName={FieldNames.FILES_ATTRIBUTES}
						/>
					</Indent>
				</AccordionComponent>
			</FormBlockComponent>
			<Indent top={14}>
				<BlockButtons>
					<BtnComponent title="orders.send" onClick={onSubmit} disabled={isEmpty} />
					<Indent left={16}>
						<BtnComponent
							title="orders.cancel_confirm"
							type={UITypes.PASSIVE}
							onClick={close}
							outline
						/>
					</Indent>
				</BlockButtons>
			</Indent>
		</>
	)
}

export const ModalFeedback = memo(
	Form.create<ComponentProps>({
		name: FormNames.MODAL.FEEDBACK,
	})(ModalFeedbackComponent)
)
